import Insurance from './views/insurance.c';
export default Insurance;
